import { Component, Input } from '@angular/core';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-header-logo',
  templateUrl: './header-logo.component.html',
  styleUrl: './header-logo.component.css'
})
export class HeaderLogoComponent {
  @Input() isScrolled: any = {};
  global: any = GlobalConstants;

}
